import { Component, OnInit } from '@angular/core';
import { AuthServiceService } from '../../services/auth-service.service';
import { INewUser, IUserProfile } from '../../interfaces/';
import { NewUser, UserProfile } from '../../models/';

@Component({
  selector: 'register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {

	user: NewUser = new NewUser();
  userProfile: UserProfile = new UserProfile();
	returnUser: INewUser = new NewUser();
  message: string = "";
  ConfirmPassword: string = "";

  constructor( private authService: AuthServiceService) { }

  ngOnInit() {
    this.user.Password = "";
  }

  createUser(){
    this.message = "";
    console.log(this.userProfile);
  	this.authService.createUser(this.user, this.userProfile).subscribe(
  		resp => {
  			this.returnUser = resp;
        console.log(resp);
        if(resp.Id != null && resp.Id != 0){
          sessionStorage.setItem("referred", 'new-account');
          location.assign('/#/account');
        }
        else {
          this.message = "Either the username or email you have chosen is already taken."
        }
  		}
  	)
  }

}



// WEBPACK FOOTER //
// ./src/app/account/register/register.component.ts